module.exports = __webpack_public_path__ + "img/play.25fdb21f.svg";